module.exports = __webpack_public_path__ + "img/zuoyef.d9791f2c.png";